import { render, staticRenderFns } from "./UserLocksTab.vue?vue&type=template&id=5381dc1f&scoped=true&"
import script from "./UserLocksTab.vue?vue&type=script&lang=js&"
export * from "./UserLocksTab.vue?vue&type=script&lang=js&"
import style0 from "./UserLocksTab.vue?vue&type=style&index=0&id=5381dc1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381dc1f",
  null
  
)

export default component.exports